import Vue from 'vue'
import title from './fragments/title'
import displacement from './mapDisplacementContent'
import needsAuthorization from './mapNeedsAuthorizationContent'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const displacementAndAuthorization = (data) => {
  return `
    <details>
      ${title(translate(area + 'displaceAndAuthorization'))}
      <content>
        <div class="row no-gutters">
          <div class="col">
            ${displacement(data)}
          </div>
          <div class="col">
            ${needsAuthorization(data)}
          </div>
        </div>
      </content>
    </details>
  `
}

export default displacementAndAuthorization
